<template>
  <RequestLoginCode
    v-if="currentStep === 'request'"
    @code-requested="handleCodeRequested"
  />

  <ConfirmLoginCode
    v-else-if="currentStep === 'confirm'"
    :email="email"
    @code-confirmed="handleCodeConfirmed"
  />

  <div v-else class="content-space-2 p-5 mb-5">
    <div class="flex-grow-1 d-flex flex-column justify-content-center mt-5">
      <div class="flex-grow-0 flex-shrink-0 container">
        <div class="row justify-content-md-center">
          <div class="col col-lg-12">
            <div class="bg-white shadow rounded-4">
              <div class="p-5 text-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import RequestLoginCode from './RequestLoginCode.vue'
import ConfirmLoginCode from './ConfirmLoginCode.vue'
import { useUserStore } from '../../stores/userStore'

const router = useRouter()
const userStore = useUserStore()

const currentStep = ref('request')
const email = ref('')

onMounted(() => {
  // Check if we have an email from a previous login code request
  const storedEmail = userStore.loginFlowEmail
  if (storedEmail) {
    email.value = storedEmail
    currentStep.value = 'confirm'
    // Clear the stored email to avoid persisting sensitive data
    userStore.clearLoginFlowEmail()
  }
})

// Handle successful code request
function handleCodeRequested(emailValue) {
  email.value = emailValue
  currentStep.value = 'confirm'
}

// Handle successful code confirmation
async function handleCodeConfirmed() {
  // Fetch user details after successful login
  await userStore.fetchUserDetails()

  // Check for stored return route first
  if (userStore.returnRoute) {
    const route = userStore.returnRoute
    userStore.clearReturnRoute()
    router.push(route)
  } else {
    // Fall back to URL parameter if no stored route
    const returnUrl = new URLSearchParams(window.location.search).get('next')
    if (returnUrl && returnUrl.startsWith('/')) {
      router.push(returnUrl)
    }
  }
}
</script>
